module.exports = __webpack_public_path__ + "assets/img/a8ea9956c4ff3da48aca25dc4c1fbc79.png";